import React from 'react'
import { TabPanel as ChakraTabPanel, TabPanelProps } from '@chakra-ui/react'

export const TabPanel: React.FC<
  Pick<TabPanelProps, 'as' | 'sx' | 'children' | 'tabIndex'>
> = props => <ChakraTabPanel {...props} />
